import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ palette, breakpoints, transitions }) => ({
    root: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      zIndex: 0,
      height: '100%',
      width: '50%',
      [breakpoints.up('sm')]: {
        width: '50%',
      },
      '& svg': {
        fill: ({ color }) => color || palette.primary.main,
        height: '100%',
        width: '100%',
        opacity({ isFullyOpaque }) {
          return isFullyOpaque ? 1 : 0.08;
        },
        transition: transitions.create('fill', {
          duration: transitions.duration.standard,
        }),
      },
    },
    fullWidth: {
      width: '100%',
      [breakpoints.up('sm')]: {
        width: '50%',
      },
    },
  }),
  { classNamePrefix: 'TriangleBackgroundContainer' }
);

export default function TriangleBackgroundContainer({
  classes: customClasses = {},
  color = '',
  withFullWidthResponsive = false,
  isHorizontallyFlipped = false,
  isFullyOpaque = false,
}) {
  const classes = useStyles({ color, isFullyOpaque, classes: customClasses });

  const points = isHorizontallyFlipped ? '100,100 0,100 0,0' : '100,100 100,0 0,100';

  return (
    <div className={`${classes.root} ${withFullWidthResponsive ? classes.fullWidth : ''}`}>
      <svg aria-hidden="true" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polygon points={points} />
      </svg>
    </div>
  );
}
